import { render, staticRenderFns } from "./LockButton.vue?vue&type=template&id=434d1e7a&scoped=true"
import script from "./LockButton.vue?vue&type=script&lang=js"
export * from "./LockButton.vue?vue&type=script&lang=js"
import style0 from "./LockButton.vue?vue&type=style&index=0&id=434d1e7a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d1e7a",
  null
  
)

export default component.exports